import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import dataReducer, { DataReducers } from "./Data/DataReducer";

// To OOTB reducers adding our dataReducers by casting into any type
(reducers as any).BrasselerSurgical = dataReducer;

export type CustomReducers = {
    BrasselerSurgical: typeof dataReducer;
};

type Reducers = Omit<typeof reducers, "BrasselerSurgical">;

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions =
    | Parameters<Reducers[keyof Reducers]>[1]
    | Parameters<DataReducers[keyof DataReducers]>[1]
    | AnyAction;
